import type { Component } from 'vue';

export enum EModalName {
  login = 'login',
  signup = 'signup',
  forgot = 'forgot',
  reset_password = 'reset_password',
  unlock = 'unlock',
  deposit = 'deposit',
  deposit_currencies = 'deposit_currencies',
  confirm = 'confirm',
  unlock_result = 'unlock_result',
  freespins = 'freespins',
  bonuses = 'bonuses',
  level_up = 'level_up',
  notification = 'notification',
  profile = 'profile',
  welcome = 'welcome',
  cashier = 'cashier',
  compoints = 'compoints',
  transaction_history = 'transaction_history',
  race = 'race',
  bonus_promo = 'bonus_promo',
  cooling_off_period = 'cooling_off_period',
  withdraw = 'withdraw',
  confirm_signup = 'confirm_signup',
  confirm_cross_sales = 'confirm_cross_sales',
  buy_crypto = 'buy_crypto',
  search = 'search',
  fiat_currencies = 'fiat_currencies',
  estonian = 'estonian',
  freespin_games = 'freespin_games',
  before_cancel_bonus = 'before_cancel_bonus',
}

export interface IModalParams {
  modal?: EModalName;
  closeAll?: boolean;
  redirect?: boolean;
  [key: string]: any;
}

export interface IModalSelectorTab {
  title: string;
  componentName: EModalName;
}

export interface IModalComponent {
  // eslint-disable-next-line @typescript-eslint/consistent-type-imports
  component: Promise<typeof import('*.vue')>;
  loading: Component;
}
